import React, { useState } from 'react'
import { Table, TableComponent } from 'components/Table'

export default function Seguridad() {
  const [TableData] = useState(
    Table.Data([
      Table.Field('idpropietario', 'Propietario'),
      Table.Field('sistema', 'Sistema'),
      Table.Field('modulo', 'Módulo'),
      Table.Field('descripcion', 'Descripción'),
      Table.Field('nivel', 'Nivel'),
    ], [
      ...Table.DefaultActions(),
    ],
      Table.Config('proceso', 'descripcion', 'idproceso')
    )
  )
  
  return (
    <div>
      <h2>Seguridad</h2>
      <TableComponent
        data={TableData}
      />
    </div>
  )
}
